<script setup lang="ts"></script>
<!--	max-w-[100dvw] w-dvw min-h-dvh-->

<template>
	<div data-theme="light" class="relative h-full overflow-hidden">
		<main
			class="h-full fixed inset-0 overflow-auto grid place-items-center"
		>
			<slot></slot>
		</main>
	</div>
</template>

<style scoped></style>
